import { getDate } from "./dateTimeHelper";

type GetFileNameWithDateParams = {
    filename?: string;
    extension: string;
}

export function getFileNameWithDate({filename = '', extension}: GetFileNameWithDateParams) {
    return `${filename}${getDate({ dateFormat: 'ymd', timeFormat: 'his' }).fullDateStr.replace(' ', '')}.${extension}`
}